import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Legacy URL: forwards to the same route editor used for the transportation schedule. */
const UpdateDailyTemplateRoute = () => {
  const { id, routeId } = useParams();
  if (!id || !routeId) return null;
  const qs = new URLSearchParams({ dailyTemplateId: id, editSection: "info" });
  return <Navigate to={`/trans-routes/edit/${encodeURIComponent(routeId)}?${qs.toString()}`} replace />;
};

export default UpdateDailyTemplateRoute;
